import { Box, IconButton, Typography } from "@mui/material";
import { PencilIcon } from "../../../assets/icons/MUI/ChatIcons";
import SearchBar from "./SearchBar";
import ChatFilterTabs from "./ChatFilterTabs";
import ChatList from "./ChatList";
import { Chat } from "../../../types";
import { useState } from "react";
import NewChatPopUp from "../../../shared/NewChatPopUp";
import { useTranslation } from "react-i18next";

const ChatSideBar = ({
  userId,
  chats,
  isUnreadActive,
  setIsUnreadActive,
  searchValue,
  setSearchValue,
  isLoading,
}: {
  userId: number | null;
  chats: Chat[];
  isUnreadActive: boolean;
  setIsUnreadActive: React.Dispatch<React.SetStateAction<boolean>>;
  searchValue: string;
  setSearchValue: React.Dispatch<React.SetStateAction<string>>;
  isLoading: boolean;
}) => {
  const { t } = useTranslation();
  const [openCreateMessage, setOpenCreateMessage] = useState<boolean>(false);

  return (
    <Box
      sx={{
        padding: "30px 0",
        borderInlineEnd: "1px solid #EAECF0",
        width: "300px",
        maxHeight: "100%",
      }}
    >
      <Box
        sx={{
          padding: "0 15px",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginBottom: "27px",
        }}
      >
        <Typography variant="h4ExtraBold">{t("pages.chat.chat")}</Typography>
        <IconButton onClick={() => setOpenCreateMessage(true)}>
          <PencilIcon style={{ fill: "none" }} />
        </IconButton>
        {openCreateMessage && (
          <NewChatPopUp
            open={openCreateMessage}
            handleClose={() => setOpenCreateMessage(false)}
          />
        )}
      </Box>
      <SearchBar searchValue={searchValue} setSearchValue={setSearchValue} />
      <ChatFilterTabs
        isUnreadActive={isUnreadActive}
        setIsUnreadActive={setIsUnreadActive}
      />
      <ChatList chats={chats} userId={userId} isLoading={isLoading} />
    </Box>
  );
};

export default ChatSideBar;
